import EditDriverTipsModal from './EditDriverTipModal';

export default EditDriverTipsModal;
